"use strict";

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);

/**
 * it-header-group-cell
 */
ngModule.directive('itHeaderGroupCell', function () {
  return {
    restrict: "A",
    require: "^infiniTable",
    scope: true,
    link: function link($scope, $el, $attrs, tableCtrl) {
      var group = $scope.group;
      if (group && group.id) {
        $el.attr('data-group-id', group.id);
      }
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/infiniTable/common/itHeaderGroupCell.js
// module id = 2797
// module chunks = 13